const listProductsSeguridadHigiene = [

    {
        id: 1,
        src: require("@/images/higiene/img1.png"),
        name: "Cepillos Bambu",
        code: "LM-SH001",
        flex: 12,
    },
    {
        id: 2,
        src: require("@/images/higiene/img2.png"),
        name: "Alcohol en Gel",
        code: "LM-SH002",
        flex: 12,
    },{
        id: 3,
        src: require("@/images/higiene/img3.png"),
        name: "Botas Plasticas",
        code: "LM-SH003",
        flex: 12,
    },{
        id: 4,
        src: require("@/images/higiene/img4.png"),
        name: "Cabina Desinfectante",
        code: "LM-SH004",
        flex: 12,
    },{
        id: 5,
        src: require("@/images/higiene/img5.png"),
        name: "Guantes",
        code: "LM-SH005",
        flex: 12,
    },{
        id: 6,
        src: require("@/images/higiene/img6.png"),
        name: "Identificador",
        code: "LM-SH006",
        flex: 12,
    },{
        id: 7,
        src: require("@/images/higiene/img7.png"),
        name: "Impremeable para Zapatos",
        code: "LM-SH007",
        flex: 12,
    },{
        id: 8,
        src: require("@/images/higiene/img8.png"),
        name: "Kit Calzado",
        code: "LM-SH008",
        flex: 12,
    },{
        id: 9,
        src: require("@/images/higiene/img9.png"),
        name: "Lentes protectores",
        code: "LM-SH009",
        flex: 12,
    },{
        id: 10,
        src: require("@/images/higiene/img10.png"),
        name: "Mascarilla Cubre Rostro",
        code: "LM-SH010",
        flex: 12,
    },
    {
        id: 11,
        src: require("@/images/higiene/img11.png"),
        name: "Mascarillas",
        code: "LM-SH011",
        flex: 12,
    },
    {
        id: 12,
        src: require("@/images/higiene/img12.png"),
        name: "Pulverizador con fácil movilidad",
        code: "LM-SH012",
        flex: 12,
    },
    {
        id: 13,
        src: require("@/images/higiene/img13.png"),
        name: "Overol antibacterial",
        code: "LM-SH013",
        flex: 12,
    },
  ]
  
  export { listProductsSeguridadHigiene }